import React, { forwardRef, memo } from "react";
import { Box } from "@chakra-ui/react";
import { Picker } from "emoji-mart-virtualized/dist-es/index";
import { translate as trans } from "../Trans/Trans";

import "emoji-mart-virtualized/css/emoji-mart.css";

const wrapperStyles = {
  ".emoji-mart": {
    border: "none",
    background: "none",
    borderRadius: "initial",
    font: "inherit",
  },
  ".emoji-mart-category-label": {
    fontSize: "sm",
  },
  ".emoji-mart-category-label span": {
    marginTop: "4px",
    background: "transparent",
    color: "#fff",
  },
  ".emoji-mart-search input": {
    fontSize: "sm",
    paddingBottom: "4px",
    paddingTop: "5px",
    marginBottom: "10px",
    marginTop: "10px",
  },
  ".emoji-mart-search-icon": {
    top: "2px",
  },
  ".emoji-mart-emoji span": {
    cursor: "inherit",
    display: "inline-flex !important",
    alignItems: "center",
    justifyContent: "center",
  },
  ".emoji-mart-no-results": {
    paddingTop: "0",
  },
  ".emoji-mart-scroll": {
    overflowY: "unset", // fixes double scroll bug
  },
};

const defaultOptions = {
  title: "",
  emoji: "",
  color: "var(--chakra-colors-brand-primary)",
  native: true,
  autoFocus: true,
  showPreview: false,
  showSkinTones: false,
  emojiTooltip: true,
  theme: "dark",
  i18n: {
    search: trans("emoji.search"),
    clear: trans("emoji.clear"), // Accessible label on "clear" button
    notfound: trans("emoji.not_found"),
    skintext: trans("emoji.skin_text"),
    categories: {
      search: trans("emoji.category.search"),
      recent: trans("emoji.category.recent"),
      smileys: trans("emoji.category.smileys"),
      people: trans("emoji.category.people"),
      nature: trans("emoji.category.nature"),
      foods: trans("emoji.category.foods"),
      activity: trans("emoji.category.activity"),
      places: trans("emoji.category.places"),
      objects: trans("emoji.category.objects"),
      symbols: trans("emoji.category.symbols"),
      flags: trans("emoji.category.flags"),
      custom: trans("emoji.category.custom"),
    },
    categorieslabel: trans("emoji.categories_label"), // Accessible title for the list of categories
    skintones: {
      1: trans("emoji.skin_tone.1"),
      2: trans("emoji.skin_tone.2"),
      3: trans("emoji.skin_tone.3"),
      4: trans("emoji.skin_tone.4"),
      5: trans("emoji.skin_tone.5"),
      6: trans("emoji.skin_tone.6"),
    },
  },
};

const EmojiPicker = forwardRef(({ ...props }, ref) => (
  <Box sx={wrapperStyles}>
    <Picker ref={ref} {...defaultOptions} {...props} />
  </Box>
));

EmojiPicker.defaultProps = {};

EmojiPicker.propTypes = {};

export default memo(EmojiPicker);
